/**
 * Created by lari on 27/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('consultexamlist', {
      restrict: 'E',
      bindings: {
        examinations: '='
      },
      template: `
      <uib-accordion close-others="oneAtATime">
        <div uib-accordion-group ng-repeat="exam in vm.examinations | filter: {active: true}"
                       is-open="status.isOpen[$index]">
      <!-- exam header -->
      <uib-accordion-heading>
      <div class="row">
        <div class="col-xs-12 col-sm-9">
          
          <span style="position:absolute; top:20%; margin-right: 1em">
            <span ng-show="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index]"><i class="fa fa-caret-up fa-2x text-primary"></i></span>
            <span ng-hide="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index]"><i class="fa fa-caret-down fa-2x text-success"></i></span>&nbsp;
          </span>
          <span style="display: inline; position:relative; left: 2em">
            <h4>{{exam.template.displayname}}</h4>
            <p>{{exam.diagnosis}}</p>
          </span>
          
          <!--          <h4>
            <span ng-show="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index]"><i class="fa fa-caret-up"></i></span>
            <span ng-hide="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index]"><i class="fa fa-caret-down"></i></span>
            &nbsp;{{exam.template.displayname}}
          </h4>
          <p>{{exam.diagnosis}}</p>-->
        </div>
        <div class="col-xs-12 col-sm-3" style="text-align: right">
          <h4>
            <a class="btn btn-primary btn-sm" href="/routes/pdfreader/{{exam.docid}}" target="_blank" uib-tooltip="PDF Ansicht">
              <i class="fa fa-eye"></i>
            </a>
            <a class="btn btn-primary btn-sm" href="/routes/pdfdownload/{{exam.docid}}"  uib-tooltip="PDF speichern">
              <i class="fa fa-download"></i>
            </a>
            <!-- editing is not really needed here? -->
<!--            <a class="btn btn-primary btn-sm" ng-click="$event.stopPropagation(); editexam[$index] = true;"
               ng-hide="vm.showeditor(exam.open, editexam[$index])"
               uib-tooltip="Editieren">
              <i class="fa fa-edit"></i>
            </a>-->
      <!--      <a class="btn btn-danger btn-sm" ng-really-click="vm.deleteExam(exam)" ng-really-message="Wollen Sie diese Untersuchung wirklich l&ouml;" uib-tooltip="Untersuchung l&ouml;schen">
              <i class="fa fa-remove"></i></a>-->
          </h4>
        </div>
      </div>
      </uib-accordion-heading>
    <!-- exam data -->
    <div class="row">
      <examview exam="exam"></examview>
    </div>
    </div>  <!-- exam in openConsult.examinations -->
    </uib-accordion>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog',
        function ($log, Rlog) {
          var vm = this;
          vm.deleteExam = deleteExam;
          vm.showeditor = showeditor;
          vm.showview = showview;
          /*          vm.$onInit = function () {

           };*/

          function showeditor (open, edit) {
            return ((open === true && (angular.isUndefined(edit) || edit === true)) ||
              (open === false && edit === true));
          }


          function showview (open, edit) {
            return ((open === true && edit === false) ||
              (open === false && (edit === false || angular.isUndefined(edit))));
          }


          function deleteExam (exam) {
            exam.active = false;
            exam.open = false;
            exam.$save().$then(function (){}, function () {
              Rlog.debug('exam', 'currentexams', 'exam delete save failed', {examid: exam._id});
            });
          }


        }] // controller
    }); // component

// klammerfriedhof
}());